import config from "appConfig";
import { LayoutComponents } from "@jelly/lesson";

const components: LayoutComponents = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/30/principle/fc-50Hz-mL-piover2-r-2.5cm-left.svg`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "image",
        options: {
          src: `${config.ASSETS_URL}/01/30/principle/fc-50Hz-mL-piover2-r-2.5cm-right.svg`,
        },
      },
      styles: {
        padding: "2%",
      },
    },
  },
];

export default components;
